exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-agency {\n  color: white;\n  width: 80px;\n  padding-top: 5px; }\n\n.save-agency {\n  width: 80px;\n  padding-top: 5px; }\n\n.current-agencies {\n  width: 400px; }\n\n.new-agency {\n  width: 400px; }\n\n.loading-sm {\n  position: absolute;\n  z-index: 3;\n  background: #ffffff45;\n  width: 100%;\n  font-size: 13px;\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/frames/parent-agency/parent-agency.component.scss
// module id = ../../../../../src/app/main/frames/parent-agency/parent-agency.component.scss
// module chunks = main